export const AnalyticsDocumentTitle = 'Analytics';
